import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class RegexService {
  constructor() {}

  number = new RegExp("^([1-9][0-9]*)$");
  positiveNegativeNumber=/^-?[0-9]\d*(\d+)?$/;
  phoneNumber = /^[6-9]\d{9}$/;
  alphaNumerical = new RegExp("^s*([0-9a-zA-Z]*)s*$");
  alphaNumericalWithSpace = /^[\w\d\s]+$/
  email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  wordsWithSpace = new RegExp("^[a-zA-Z][a-zA-Z ]*$");
  positiveDecimalDigit = /^\.?(?!-)\d+(?:\.\d{1,2})?$/;
  indianPincode = /^[1-9]{1}\d{5}$/;
  intigers = new RegExp("^[1-9][0-9]*$");
  alphabets = new RegExp("^[a-zA-Z]*$");
  csvValidation = /\.(csv|CSV)$/;
  otp = /^[\d]{6}$/;
  companyName = /^[.@&]?[a-zA-Z0-9 ]+[ !.@&()]?[ a-zA-Z0-9!()]+/;
  passwordPattern = new RegExp(
    "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
  );
  website = /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?\/?$/;
  currency = /^[A-Za-z]{3}$/;
  orderTotal = /^[0-9]+\.?[0-9]*$/;

  urlWithHttp = /^(?:http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
  urlOptionalHttp = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;

  urlForDisputeImages=/[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\-+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/
  // Minimum 5 chars
  addressRegex = /^.{5,}$/;

  // Regex for landline as well as mobile numbers
  // https://stackoverflow.com/questions/3813195/regular-expression-for-indian-mobile-numbers
  // allPhoneNumber = new RegExp(
  //   /^(?:(?:\+|0{0,2})91(\s*[\ -]\s*)?|[0]?)?[6-9]\d{9}|(\d[ -]?){10}\d$/
  // );

  // https://www.immihelp.com/phone-numbering-scheme-in-india/
  allPhoneNumber = /^[1-9]\d{9}$|^[6-9]\d{9}$/

  // nonZeroPositiveDecimalDigit for LxBxH of Box
  nonZeroPositiveDecimalDigit = new RegExp(
    /^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/
  );

  // SAMPLE PAN AAAAA0000A
  // SAMPLE GST 22AAAAA0000A1Z5
  // Sample IFSC SBIN0000058
  ifsc = /^[a-zA-Z]{4}[0-9]+$/;
  pan = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
  gst = /^([0][1-9]|[1-2][0-9]|[3][0-5])([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$/;
  gstin = /^[0-3][0-9][A-Z]{5}[0-9]{4}[A-Z][1-9A-Z][A-Z][A-Z0-9]$/;
  pdf = /\.pdf$/;

  bankAccountNo = new RegExp("^([0-9]*)$");

  /**
   * Text without emoji
   * https://stackoverflow.com/questions/51379147/how-to-add-a-emoji-regex-validation-in-js#
   */

  textWithoutEmoji = new RegExp(
    /^(?:(?!(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff]))[^`~!+,!@#%^&*();\/|<>"0-9=[\]{}_☺]){1,255}$/
  );

  /**
   * Comma separated values
   * https://stackoverflow.com/questions/25925393/regexp-to-capture-comma-separated-values
   */

  commaSeparated = new RegExp("^w+(,w+)*$");

  // /[-\w\s#$&]+(,[-\w\s#$&]+)*/
  commaSeparatedOrderNumber = /^([-\w#$&@]+,)*[-\w#$&@]+$/;
  commaSeparatedPincode = /^([1-8]{1}\d{5},)*([1-9]{1}\d{5})$/;

  // commaSeparatedPincodes = /^(([1-9]d{9}),([1-9]d{9}))$/;

  paymentType = /^(ppd|cod)$/i;
  lessThanFifty = /^(?:[1-9]|[1-4][0-9]|50)$/;

  // 0 to 999
  percentage = /^([1-9]([0-9])?([0-9])?)(\.[0-9]{1,2})?$/
  
}
